var React = require('react');

function HomeOffice (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 2.586L2.293 16.293l1.414 1.414L5 16.414V28h11v-2H7V14.414l9-9 8.605 8.605L25 14c1.397 0 2.68.484 3.701 1.287L25 11.586V7h-2v2.586l-7-7zM25 16c-2.2 0-4 1.8-4 4v2h-3v10h14V22h-3v-2c0-2.2-1.8-4-4-4zm0 2c1.1 0 2 .9 2 2v2h-4v-2c0-1.1.9-2 2-2zm-5 6h10v6H20v-6z"}));
}

HomeOffice.defaultProps = {"viewBox":"0 0 32 32","xmlnsV":"https://vecta.io/nano"};

module.exports = HomeOffice;

HomeOffice.default = HomeOffice;
